import { TableCell, TableRow } from '@repo/shadcn';

type TableLoaderProps = {
    columnLength?: number;
};

export const TableLoader = ({ columnLength = 1 }: TableLoaderProps) => {
    return (
        <TableRow>
            <TableCell colSpan={columnLength} className="py-8 text-center">
                <div className="flex w-full items-center justify-center space-x-2">
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-900 border-b-transparent"></div>
                    <span>Loading...</span>
                </div>
            </TableCell>
        </TableRow>
    );
};

TableLoader.displayName = 'TableLoader';
